const DEVICE_ID_KEY = 'sos.signal.deviceId';

export function getDeviceId() {
  const existing = localStorage.getItem(DEVICE_ID_KEY);

  if (existing) {
    return existing;
  }

  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  const deviceId = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  localStorage.setItem(DEVICE_ID_KEY, deviceId);
  return deviceId;
}

export function getDeviceLabel() {
  const platform = navigator.platform || 'unknown platform';
  const standalone = window.matchMedia('(display-mode: standalone)').matches ? 'installed' : 'browser';
  return `${platform} ${standalone}`;
}
